<pgh-modal-window>
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-title>
    <div class="mb-10">
      <pgh-avatar name="{{ fullName }}" color="{{ member?.profileColor }}" size="75"></pgh-avatar>
      <!--<img [src]="memberAvatarUrl  || 'src/assets/images/avatars/desktop.png'"class="current-avatar mb-2 avatar-size" alt="{{requestorFirstName}}'s Avatar" />-->
    </div>
    <h4>
      <adp-label labelKey="Account_Manage_Members_DeleteMember_Heading"></adp-label>
    </h4>
  </div>
  <div modal-body class="mt-30 mb-30 text-center text-color">
    <span class="fw-600">
      <adp-label [context]="adpData" labelKey="Account_Manage_Members_DeleteMember_ConfirmMsgTop"></adp-label>
    </span>
    <br /><br />
    <span>
      <adp-label labelKey="Account_Manage_Members_DeleteMember_ConfirmMsgBottom"></adp-label>
    </span>
  </div>
  <div modal-footer class="row reverse-wrap">
    <div class="col-md-6">
      <button
        mat-stroked-button
        color="primary"
        class="border-0"
        (click)="onCancelClicked()"
        [gtmClick]="getViewLabel('Global_Button_Cancel')">
        <adp-label labelKey="Global_Button_Cancel"></adp-label>
      </button>
    </div>
    <div class="col-md-6">
      <button
        mat-flat-button
        color="accent"
        (click)="onDeleteClicked()"
        [disabled]="isSaving"
        [gtmClick]="getViewLabel('Global_Button_Delete')">
        <adp-label labelKey="Global_Button_Delete"></adp-label>
      </button>
    </div>
  </div>
</pgh-modal-window>
